module.exports = __webpack_public_path__ + "img/56_12apostles.cc2c87f2.jpg";